module.exports = __webpack_public_path__ + "img/shark-not-found.b6be4c3f.svg";